import React from 'react';
import PropTypes from 'prop-types';

const { AggregatorTableDetails } = require('../aggregatorTableDetails/aggregatorTableDetails');

const { FormattedText } = require('core/i18n').i18n;

const TRANSLATION_KEY_PREFIX = 'aggregatorAccountBoxDetailsHeader';

import { getCategoryIconURL } from 'utilities/expensesByCategories/categoriesUtilities';

class AggregatorAccountDetails extends React.Component {
  buildItem(item) {
    const { isTinkAggregator } = this.props;

    const date = item.get('date');
    const category = isTinkAggregator
      ? item.getIn(['category', 'categoryCode'])
      : item.get('category');
    const subCategory = isTinkAggregator
      ? item.getIn(['category', 'subcategoryCode'])
      : item.get('subCategory');
    const categoryIconUrl = isTinkAggregator
      ? getCategoryIconURL(`category_${category}`)
      : item.get('categoryIconUrl');
    const description = isTinkAggregator ? item.get('concept') : item.get('description');
    const quantity = isTinkAggregator ? item.get('amount') : item.get('quantity');
    const amount = isTinkAggregator ? item.get('balance') : item.get('amount');

    return [
      {
        type: 'date',
        value: date,
      },
      {
        type: 'category',
        value: {
          category: category,
          subcategory: subCategory,
          icon: categoryIconUrl,
        },
      },
      {
        type: 'text',
        value: description,
      },
      {
        type: 'amount',
        value: quantity,
      },
      {
        type: 'amount',
        value: amount,
      },
    ];
  }

  buildTableValues = () => {
    const { details } = this.props;

    let tableValues = details.get('movements', []) || [];

    return tableValues.map(item => this.buildItem(item));
  };

  buildTableHeader = () => {
    const { isTinkAggregator } = this.props;

    return [
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-date`}
        value={`${TRANSLATION_KEY_PREFIX}-date`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-category`}
        value={`${TRANSLATION_KEY_PREFIX}-category`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-description`}
        value={`${TRANSLATION_KEY_PREFIX}-description`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-amount`}
        value={`${TRANSLATION_KEY_PREFIX}-amount`}
      />,
      // Tink doesn´t provide the relative balance
      !isTinkAggregator && (
        <FormattedText
          key={`${TRANSLATION_KEY_PREFIX}-total`}
          value={`${TRANSLATION_KEY_PREFIX}-total`}
        />
      ),
    ];
  };

  render() {
    const { details } = this.props;
    const header = this.buildTableHeader();
    const values = this.buildTableValues();
    const textButton = (
      <FormattedText value={'aggregatorAccountDetails-showMoreDetails'} format="uppercase" />
    );
    const loading = details.get('loading');

    return (
      <AggregatorTableDetails
        values={values}
        header={header}
        hasMore={true}
        toButton={`/myprofile/global/entities/accounts/${this.props.productId}`}
        textButton={textButton}
        loading={loading}
      />
    );
  }
}

AggregatorAccountDetails.propTypes = {
  details: PropTypes.object,
  productId: PropTypes.string,
  isTinkAggregator: PropTypes.bool,
};

export { AggregatorAccountDetails };
